import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_INVESTMENT_TIMELINE } from "../../../config/api";

export const editTimeline = createAsyncThunk(
  "timeline/edit",
  async ({ payload, cb, setSubmitting, id }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "PUT",
        path: `${API_INVESTMENT_TIMELINE}/${id}`,
        data: payload,
      });
      toast.success("Timeline updated successfully");

      setSubmitting(false);
      cb();
      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      setSubmitting(false);
      return rejectWithValue(error.message);
    }
  }
);
